import { useCallback } from "react";

import { storeAllData } from "../../services/apiServices";

/**
 * POSTs the post-stream conversation snapshot to the persistence
 * endpoint.
 *
 * Phase 5 of plans/useChatHook-enterprise-grade.md moved the status
 * state out of this hook and into the chat reducer; the hook is now a
 * thin async wrapper that dispatches lifecycle transitions
 * (SAVE_START, SAVE_SUCCESS, SAVE_ERROR). The 3-second auto-clear of
 * `saved → idle` lives in useChatHook as a useEffect on the reducer
 * state, so timer cleanup is attached to the composition root's mount.
 */
export function useStoreConversation({ clientId, dispatch }) {
  const save = useCallback(
    async (conversation) => {
      dispatch({ type: "SAVE_START" });
      try {
        const data = await storeAllData(clientId, conversation);
        dispatch({ type: "SAVE_SUCCESS", data });
        return data;
      } catch (err) {
        const message = err?.response?.data?.error || err?.message;
        dispatch({ type: "SAVE_ERROR", message });
        throw err;
      }
    },
    [clientId, dispatch],
  );

  return { save };
}
